/**
 * Message à afficher pour un appel en échec : celui de l'API quand il existe
 * (le backend renvoie `{ error: "…" }` en français), sinon un message selon le statut.
 */
export function messageErreur(erreur: unknown, reponse?: Response): string {
  if (erreur && typeof erreur === 'object' && 'error' in erreur && typeof erreur.error === 'string' && erreur.error) {
    return erreur.error;
  }
  if (!reponse) return 'Serveur injoignable. Vérifiez votre connexion.';
  switch (reponse.status) {
    case 401:
      return 'Session expirée. Reconnectez-vous.';
    case 403:
      return 'Action réservée au super admin.';
    case 404:
      return 'Introuvable.';
    case 429:
      return 'Trop de tentatives. Réessayez dans quelques minutes.';
    default:
      return `Erreur ${reponse.status}. Réessayez ou prévenez l'équipe technique.`;
  }
}
